class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.cartIcon = document.getElementById('cart-icon-bubble');
    this.overlay = this.querySelector('#cart-notification-overlay');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    if (this.cartIcon) {
      this.cartIcon.addEventListener('click', this.handleCartIconClick.bind(this));
    }

    this.addEventListener('change', this.onLineItemChange.bind(this));
    this.addEventListener('click', this.onLineItemClick.bind(this));
  }

  handleCartIconClick(evt) {
    evt.preventDefault();
    if (this.notification.classList.contains('active')) {
      this.close();
      return;
    }
    this.renderCart();
  }

  renderCart() {
    fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map((section) => section.id).join(',')}`)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedState = JSON.parse(responseText);
        this.updateSections(parsedState.sections || parsedState);
        if (this.header) this.header.reveal();
        this.open();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (this.overlay) this.overlay.classList.add('active');
    document.body.classList.add('cart-notification-open');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.classList.remove('cart-notification-open');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.updateSections(parsedState.sections);

    if (this.header) this.header.reveal();
    this.open();
  }

  updateSections(sections) {
    if (!sections) return;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (el && sections[section.id] !== undefined) {
        el.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onLineItemClick(evt) {
    const button = evt.target.closest('[data-cart-quantity-button]');
    if (!button) return;
    evt.preventDefault();

    const line = button.dataset.line;
    const action = button.dataset.cartQuantityButton;
    const input = this.querySelector(`#Notification-quantity-${line}`);
    if (!input) return;

    let newQuantity = parseInt(input.value, 10) || 0;
    if (action === 'plus') newQuantity += 1;
    if (action === 'minus') newQuantity = Math.max(0, newQuantity - 1);
    if (action === 'remove') newQuantity = 0;

    this.updateQuantity(line, newQuantity);
  }

  onLineItemChange(evt) {
    const input = evt.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    const line = input.dataset.line;
    const newQuantity = Math.max(0, parseInt(input.value, 10) || 0);

    this.updateQuantity(line, newQuantity);
  }

  updateQuantity(line, quantity) {
    this.notification.classList.add('cart-notification--loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateSections(parsedState.sections);
        this.notification.classList.remove('cart-notification--loading');
      })
      .catch((e) => {
        console.error(e);
        this.notification.classList.remove('cart-notification--loading');
      });
  }
}

customElements.define('cart-notification', CartNotification);
